const BASE_URL = 'https://api.dev.auxo.dk/public/content';

export async function fetchCollection(collectionName) {
  console.log(`Fetching collection: ${collectionName}`);
  try {
    const response = await fetch(`${BASE_URL}/${collectionName}`);
    console.log(`Response for ${collectionName}:`, response.status);
    if (!response.ok) throw new Error('Failed to fetch collection');
    const data = await response.json();
    console.log(`Data for ${collectionName}:`, data.length);
    return data;
  } catch (error) {
    console.error(`Error fetching ${collectionName}:`, error);
    return [];
  }
}

export async function fetchEntryById(collectionName, entryId) {
  try {
    const response = await fetch(`${BASE_URL}/${collectionName}/${entryId}`);
    if (!response.ok) throw new Error('Failed to fetch entry');
    return await response.json();
  } catch (error) {
    console.error(`Error fetching entry ${entryId} from ${collectionName}:`, error);
    return null;
  }
}
